// extracted by mini-css-extract-plugin
export default {"button":"SyllabusDownloadButton_button__EM2y9","fullWidth":"SyllabusDownloadButton_fullWidth__h6TuG","icon":"SyllabusDownloadButton_icon__s+qe4"};